export default "__VITE_ASSET__DmIDXdN4__"